import React from 'react';
import { asyncConnect } from 'redux-connect';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Helmet from 'react-helmet';
import { createSelector, createStructuredSelector } from 'reselect';

import { loadStaticPage } from '../../actions/staticPage';
import {
  staticPageSelector,
  staticPageErrorSelector
} from '../../selectors/staticPage';
import { createPromise, getKey } from '../../utils';
import HeroImage from '../../widgets/HeroImage';

import './StaticPage.css';

const NO_INDEX_PAGES = [
  /^(?:\/\w\w)?\/privacy_policy\/?$/,
  /^(?:\/\w\w)?\/terms_and_conditions\/?$/,
  /^(?:\/\w\w)?\/general_delivery_terms\/?$/,
  /^(?:\/\w\w)?\/api-and-affiliate-partner-program\/?$/
];

const StaticPage = ({
  data,
  location
}) => {
  const content = getKey(data, 'content');
  const description = getKey(data, 'seoDescription');
  const meta = [];

  if (description) {
    meta.push({
      name: 'description',
      content: description
    });
  }

  const noindex = NO_INDEX_PAGES.some((regex) => regex.test(location.pathname));

  if (noindex) {
    meta.push({
      name: 'robots',
      content: 'noindex'
    });
  }

  return (
    <div>
      <Helmet
        title={getKey(data, 'seoTitle')}
        meta={meta}
      />

      <HeroImage
        img={data && data.headerImage}
        title={getKey(data, 'headerTitle')}
      />

      <Grid>
        <Row>
          <Col
            lg={12}
            className="static-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Row>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  error: staticPageErrorSelector,
  data: staticPageSelector
});

export default asyncConnect([{
  promise: ({
    store,
    location: { pathname },
    helpers: { shouldWait }
  }) => {
    const chunks = pathname.split('/');
    chunks.reverse();

    const slug = chunks.find(ch => !!ch);

    const selector = createSelector(
      staticPageSelector,
      page => page && page.url === slug
    );

    return createPromise(store, shouldWait, selector, loadStaticPage, slug);
  }
}], mapStateToProps)(StaticPage);



// WEBPACK FOOTER //
// ./src/components/Static/StaticPage.js